module.exports = __webpack_public_path__ + "img/Styling.28838f99.jpeg";